export default __webpack_public_path__ + "assets/models/2f93a1e6f3a31fb93b9a6be7140663d2.glb";